export default {
      id: "icon-mail-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-mail",
      toString: function () {
        return this.url;
      }
    }